// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.folder-card--grid {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
  max-width: 200px;
  min-width: 200px;
}
.folder-card--grid:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
.folder-card--grid:focus-visible {
  outline: 2px solid #999;
  outline-offset: 2px;
}
.folder-card__cover {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  position: relative;
  overflow: hidden;
}
.folder-card__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.folder-card__icon {
  width: 32px;
  height: 32px;
}
.folder-card__body {
  padding: 8px 10px;
}
.folder-card__title {
  font-family: var(--font);
  font-weight: 600;
  font-size: 13px;
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.folder-card__meta {
  font-family: var(--font);
  font-weight: 400;
  font-size: 11px;
  margin: 0;
  opacity: 0.7;
}
.folder-card--list {
  --padding-start: 8px;
  --inner-padding-end: 8px;
}
.folder-card--list .folder-card__avatar {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}
.folder-card--list .folder-card__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.folder-card--list .folder-card__avatar-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}
.folder-card--list ion-label h2 {
  font-family: var(--font);
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.folder-card--list ion-label p {
  font-family: var(--font);
  font-weight: 400;
  font-size: 12px;
  opacity: 0.7;
}

@media (prefers-reduced-motion: reduce) {
  .folder-card--grid {
    transition: none;
  }
  .folder-card--grid:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documents/document-folder-card/document-folder-card.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAGE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;EACA,yCAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,2BAAA;EACA,0CAAA;AAAN;AAGI;EACE,uBAAA;EACA,mBAAA;AADN;AAKE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;AALJ;AAQE;EACE,iBAAA;AANJ;AASE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPJ;AAUE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;AARJ;AAWE;EACE,oBAAA;EACA,wBAAA;AATJ;AAWI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AATN;AAWM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AATR;AAYM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAVR;AAeM;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAbR;AAgBM;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAdR;;AAoBA;EACE;IACE,gBAAA;EAjBF;EAmBE;IACE,eAAA;EAjBJ;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.folder-card {\n  &--grid {\n    background: #fff;\n    border-radius: 10px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    max-width: 200px;\n    min-width: 200px;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n    }\n\n    &:focus-visible {\n      outline: 2px solid #999;\n      outline-offset: 2px;\n    }\n  }\n\n  &__cover {\n    height: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f0f0f0;\n    position: relative;\n    overflow: hidden;\n  }\n\n  &__image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__icon {\n    width: 32px;\n    height: 32px;\n  }\n\n  &__body {\n    padding: 8px 10px;\n  }\n\n  &__title {\n    font-family: var(--font);\n    font-weight: 600;\n    font-size: 13px;\n    margin: 0 0 2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__meta {\n    font-family: var(--font);\n    font-weight: 400;\n    font-size: 11px;\n    margin: 0;\n    opacity: 0.7;\n  }\n\n  &--list {\n    --padding-start: 8px;\n    --inner-padding-end: 8px;\n\n    .folder-card__avatar {\n      width: 48px;\n      height: 48px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: #f0f0f0;\n      border-radius: 4px;\n      overflow: hidden;\n\n      &-img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        border-radius: 4px;\n      }\n\n      &-icon {\n        width: 24px;\n        height: 24px;\n        border-radius: 4px;\n      }\n    }\n\n    ion-label {\n      h2 {\n        font-family: var(--font);\n        font-weight: 600;\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      p {\n        font-family: var(--font);\n        font-weight: 400;\n        font-size: 12px;\n        opacity: 0.7;\n      }\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .folder-card--grid {\n    transition: none;\n\n    &:hover {\n      transform: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
